import React, { useEffect, FC } from "react";
import { useSelector } from "react-redux";

import CloseIcon from "@material-ui/icons/Close";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked";

import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Modal, Grid, TextareaAutosize, Typography } from "@material-ui/core";

import { selectImageToken } from "../../../features/userSlice";
import { getFixedFlg } from "../../Header/Header";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    uploadGrid: {
      height: "9vh",
    },
    noUpload: {
      color: "#f2f2f2",
    },
    uploaded: {
      color: "#37ab9d",
    },
    modalPane: {
      position: "absolute",
      paddingTop: "2%",
      paddingLeft: "5%",
      width: "84%",
      height: "80%",
    },
    paper: {
      height: "100%",
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    titleGrid: {
      height: "7vh",
      color: "white",
      backgroundColor: "#4dc0b2",
    },
    titleTypography: {
      fontWeight: "bold",
    },
  })
);
const TenpoCheckModalLastScore: FC<{
  title: string;
  comment?: string;
  photoFilePath: string[];
  record: any;
  lastRenkeiList?: any[];
}> = ({ title, comment, photoFilePath, record, lastRenkeiList }) => {
  const classes = useStyles();
  const [modalComment, setModalComment] = React.useState(comment);
  const [filePath, setFilePath] = React.useState<any[]>([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const [renkeiList, setRenkeiList] = React.useState<any[]>([]);

  useEffect(() => {
    setFilePath(photoFilePath);
    createTaskIdList();
  }, [photoFilePath]);

  const createTaskIdList = () => {
    let commentMapList: any[] = record.reason_comment_map_list;
    let reasonTargetList: any[] = record.reason_target_list;
    let taskList: string[] = [];
    if (lastRenkeiList) {
      for (let comment_map of commentMapList) {
        let targetValue = comment_map.value;
        let commentList = comment_map.comment_list;
        let targetName = "";
        for (let reasonTarget of reasonTargetList) {
          if (reasonTarget.value === targetValue) {
            targetName = reasonTarget.name;
          }
        }

        for (let commentMap of commentList) {
          if (
            commentMap.task_id &&
            lastRenkeiList.indexOf(commentMap.task_id) !== -1
          ) {
            let taskName = (title = targetName + " " + commentMap.name);

            taskList.push(taskName);
          }
        }
      }
    }
    setRenkeiList(taskList);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const imageToken = useSelector(selectImageToken);
  function getImageFile(imagePath: string) {
    if (imagePath === undefined || imagePath === "") {
      return `${window.location.origin}/image/noimage.png`;
    }
    return (
      process.env.REACT_APP_CLOUD_STORAGE_URL +
      imagePath +
      "?access_token=" +
      imageToken
    );
  }
  function isUploaded(argFilePath: string, argComment: any): any {
    if (
      (argFilePath && argFilePath !== "") ||
      (argComment && argComment !== "")
    ) {
      return classes.uploaded;
    }
    return classes.noUpload;
  }

  return (
    <>
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.uploadGrid}
      >
        <Grid
          onClick={handleOpen}
          className={isUploaded(filePath[0], modalComment)}
        >
          {record.last_button_value === "1" ? (
            <RadioButtonUnchecked style={{ color: "black" }} />
          ) : (
            <CloseIcon style={{ color: "red" }} />
          )}
          {renkeiList.length > 0 ? (
            <CheckBoxIcon style={{ color: "black" }} fontSize={"small"} />
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      {/*  モーダルここから↓*/}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modalPane}
      >
        <Grid container className={classes.paper} style={{ overflowY: "auto" }}>
          {/*  タイトルここから↓*/}
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.titleGrid}
          >
            <Typography variant="h6" className={classes.titleTypography}>
              {title}
            </Typography>
          </Grid>
          {/*  タイトルここまで↑*/}
          <Grid
            container
            style={{
              marginBottom: "5px",
              display: "flex",
              alignSelf: "flex-start",
            }}
          >
            {/*  写真ここから↓*/}
            <Grid item lg={3} md={4} sm={4}>
              <Grid container justify="center" style={{ paddingTop: "10px" }}>
                <img
                  alt=""
                  src={getImageFile(filePath[0])}
                  height="200"
                  style={{
                    width: "200px",
                    WebkitAppearance: "none",
                  }}
                />
              </Grid>
            </Grid>
            {/*  写真ここまで↑*/}
            {/*  その他コメントここから↓*/}
            <Grid item lg={9} md={8} sm={8} style={{ height: "45vh" }}>
              {record.last_comment_handwrite_flag === "1" &&
              record.last_comment_filepath_gcs &&
              record.last_comment_filepath_gcs.length > 0 &&
              record.last_comment_filepath_gcs[0] !== "" ? (
                <img
                  alt=""
                  src={getImageFile(record.last_comment_filepath_gcs[0])}
                  height="200"
                  style={{
                    width: "200px",
                    marginLeft: "10px",
                    WebkitAppearance: "none",
                  }}
                />
              ) : (
                <TextareaAutosize
                  rowsMax={16}
                  aria-label="store-input-comment-area"
                  rowsMin={16}
                  maxLength={4000}
                  placeholder={"その他コメント"}
                  value={modalComment}
                  style={{
                    width: "93%",
                    fontSize: "16px",
                    borderRadius: "8px",
                    margin: "10px",
                  }}
                />
              )}
            </Grid>
            {/*  その他コメントここまで↑*/}

            <Grid
              container
              style={{
                marginBottom: "5px",
                display: "flex",
                alignSelf: "flex-start",
              }}
            >
              {renkeiList.map((row: any) => (
                <Grid container>
                  <CheckBoxIcon fontSize={"small"} />
                  {row}
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Modal>
      {/*  モーダル↑ここまで*/}
    </>
  );
};
export default TenpoCheckModalLastScore;
